import { useQuery } from "@tanstack/react-query";
import { ApiError, apiFetch } from "@/lib/api";

export interface UsuarioSessaoCliente {
  userId: string;
  email: string;
  perfil: "user" | "premium" | "admin";
  status: "active" | "inactive";
  name: string | null;
}

interface RespostaMe {
  authenticated: boolean;
  user?: UsuarioSessaoCliente;
}

export function useSessao() {
  const query = useQuery({
    queryKey: ["sessao"],
    queryFn: async (): Promise<UsuarioSessaoCliente | null> => {
      try {
        const r = await apiFetch<RespostaMe>("/api/me");
        return r.user ?? null;
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 60_000,
    retry: 0,
  });

  return {
    user: query.data ?? null,
    carregando: query.isLoading,
    autenticado: !!query.data,
    ehAdmin: query.data?.perfil === "admin",
  };
}
